module.exports = __webpack_public_path__ + "img/img12.087e9e69.png";